import React from 'react'
import styled from 'styled-components'

import AlertDescriptionForm from 'pages/shared/AlertDescriptionForm'

import { useStoreContext } from 'hooks/StoreContext'
import useAlertDescriptions from 'hooks/useAlertDescriptions'

import { PageHeader, PageTitle, LoadingSinglePanePage, SinglePanePage, screenSize } from 'styles/shared'

const AddAlertDescription = () => {
  useAlertDescriptions()

  const { areAlertDescriptionsLoaded } = useStoreContext()

  if (!areAlertDescriptionsLoaded) {
    return <LoadingSinglePanePage />
  }

  return (
    <>
      <PageHeader>
        <S.PageTitle>Add Alert</S.PageTitle>
      </PageHeader>
      <S.SinglePanePage>
        <AlertDescriptionForm
          saveMethod="create"
        />
      </S.SinglePanePage>
    </>
  )
}

export default AddAlertDescription

const S = {
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0;
    }
  `,
  PageTitle: styled(PageTitle)`
    @media ${screenSize.small} {
      display: block;
    }
  `
}
